var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"0.1.0"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// import * as Sentry from "@sentry/nextjs";

// Sentry.init({
//     dsn: "https://8fb63dc8d42d4953a182a830392cd108@glitch.nphl.go.ke/1",
//     release: process.env.npm_package_version,
//     tracesSampleRate: 1.0,
//     hideSourceMaps: true,
//     disableServerWebpackPlugin: true,
//     disableClientWebpackPlugin: true,
// });
